
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.85857 5C4.67166 5.19066 4.49233 5.38877 4.32106 5.59384C2.87201 7.32892 2 9.56263 2 12C2 17.5228 6.47715 22 12 22C14.4374 22 16.6711 21.128 18.4062 19.6789C18.6112 19.5077 18.8093 19.3283 19 19.1414C19.0476 19.0948 19.0948 19.0476 19.1414 19C19.3752 18.7615 19.5971 18.5114 19.8062 18.2506C21.1789 16.5385 22 14.3651 22 12C22 6.47715 17.5228 2 12 2C9.63486 2 7.4615 2.82109 5.74941 4.19376C5.48858 4.40288 5.23846 4.6248 5 4.85857C4.95239 4.90524 4.90524 4.95239 4.85857 5ZM5.74235 7.01513L16.9849 18.2576C15.6167 19.3495 13.8856 20 12 20C7.58172 20 4 16.4183 4 12C4 10.1144 4.65049 8.3833 5.74235 7.01513ZM18.3814 16.8257L7.17426 5.61861C8.51636 4.60156 10.1865 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8135 19.3984 15.4836 18.3814 16.8257Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiMouseDisableFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
